import { createContext, Fragment, useState } from 'react'

import { ContentNote } from 'globalTypes'
import ReactSlidingPane from 'react-sliding-pane'

import { useLazyQuery } from '@apollo/client'

import Form from './Form'
import Loading from './Loading'
import QUERY from './content-note.graphql'

interface ContextProps {
  elementId?: string
  setElementId: Function
}

export const Context = createContext<ContextProps>({
  elementId: undefined,
  setElementId: () => ({}),
})
Context.displayName = 'NoteContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const NoteContext = ({ children }: Props) => {
  const [loadNote, { data, loading }] = useLazyQuery<ContentNote>(QUERY, {
    fetchPolicy: 'network-only',
  })
  const [elementId, _setElementId] = useState<string | undefined>()

  const setElementId = (value: string | undefined) => {
    _setElementId(value)

    if (Boolean(value)) {
      loadNote({
        variables: {
          id: value,
        },
      })
    }
  }

  const value = {
    elementId,
    setElementId,
  }

  const isOpen = Boolean(elementId)

  return (
    <Fragment>
      <Provider value={value}>{children}</Provider>
      {isOpen && (
        <ReactSlidingPane
          from="bottom"
          hideHeader
          isOpen={isOpen}
          onRequestClose={() => setElementId(undefined)}
          overlayClassName="z-30 w-screen"
          shouldCloseOnEsc
          width="100%"
        >
          {loading ? <Loading /> : <Form content={data} id={elementId} />}
        </ReactSlidingPane>
      )}
    </Fragment>
  )
}

export default NoteContext
